import { useState, useEffect } from "react";
import PilotagePilotOvertimeActivityTypeIdbRepository from "repositories/idb/PilotagePilotOvertimeActivityTypeIdbRepository";

export interface PilotageOvertimeActivityType {
    systemName: string;
    name: string;
    pilotagePilotOvertimeActivityTypeID: number;
}

export function usePilotageOvertimeActivityType(systemName: string): { activityType: PilotageOvertimeActivityType | null } {
    const [activityType, setActivityType] = useState<PilotageOvertimeActivityType | null>(null);

    useEffect(() => {
        let isMounted = true;
        async function fetchOvertimeTypes() {
            const overtimes: PilotageOvertimeActivityType[] = await PilotagePilotOvertimeActivityTypeIdbRepository.getAllAsync();
            const overtime = overtimes.find(o => o.systemName === systemName) || null;
            if (isMounted) setActivityType(overtime);
        }
        fetchOvertimeTypes();
        return () => { isMounted = false; };
    }, [systemName]);

    return { activityType };
}
